/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.1.0
 */

import { ICommonTranslationLists } from '../../types/common/lists';

const initTranslationLists: ICommonTranslationLists = {
    densityListView: {
        buttonToggle: {
            tooltip: {
                toCompact: {},
                toDefault: {},
            },
        },
        compact: '',
        default: '',
        gtmParam: '',
    },
};

export default initTranslationLists;
